// extracted by mini-css-extract-plugin
export var button = "_47-7";
export var buttonRow = "_47-6";
export var fadeIn = "_47-1";
export var gradient = "_47-0";
export var panel = "_47-2";
export var panelIn = "_47-3";
export var subtitle = "_47-5";
export var title = "_47-4";